import cloneDeep from 'lodash/cloneDeep';
import { ACURA_SITE_NAME, ENGINE_SITE_NAME, HC_SITE_NAME, HF_SITE_NAME, HONDA_SITE_NAME, MARINE_SITE_NAME, PE_SITE_NAME, PSP_SITE_NAME, } from '../../../utils/constants';
import { mapMarineFields, mapPEFields, mapPSPFields } from './utils';
const dataMapperByAppName = {
    [PSP_SITE_NAME]: mapPSPFields,
    [MARINE_SITE_NAME]: mapMarineFields,
    [PE_SITE_NAME]: mapPEFields,
    [HONDA_SITE_NAME]: undefined,
    [ACURA_SITE_NAME]: undefined,
    [ENGINE_SITE_NAME]: undefined,
    [HC_SITE_NAME]: undefined,
    [HF_SITE_NAME]: undefined,
};
/**
 * Deep clone sitecore fields and pass down to data mapper
 *
 * @param {unknown} fields
 * @param {AppName} appName
 * @return {*}
 */
const getMappedFields = (fields, appName) => {
    const dataMapper = dataMapperByAppName[appName];
    // Maps from PSP Category/Product => Model/Trim
    // Maps from Marine Category/Product => Model/Trim
    const mappedFields = typeof dataMapper === 'function'
        ? // avoid direct mutation
            dataMapper(cloneDeep(fields))
        : fields;
    return mappedFields;
};
export default getMappedFields;
